import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'noLeadingZero',
})
export class NoLeadingZeroPipe implements PipeTransform {
  transform(value?: string | null): string {
    return value ? value.replace(/^0+/, '') : '';
  }
}
